import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `TipoDiluyente/addTipoDiluyente`, method: 'POST', body: values, token: token})
}